
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("absYu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dGmBZ = parcelRequire("dGmBZ");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $dOBRD = parcelRequire("dOBRD");


var $9DHhW = parcelRequire("9DHhW");


var $2j5oi = parcelRequire("2j5oi");

function $68460bd0ab58b973$var$traceUFOHover(name, timestamp) {
    return (0, $2j5oi.default)(name, 'hover', timestamp);
}
var $68460bd0ab58b973$export$2e2bcd8739ae039 = $68460bd0ab58b973$var$traceUFOHover;



var $jMyy4 = parcelRequire("jMyy4");


var $9HB34 = parcelRequire("9HB34");


var $euL71 = parcelRequire("euL71");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $gAcLU = parcelRequire("gAcLU");


var $8Psje = parcelRequire("8Psje");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $ep3mz = parcelRequire("ep3mz");


var $j3kZx = parcelRequire("j3kZx");


var $ivyMZ = parcelRequire("ivyMZ");


var $1oGPE = parcelRequire("1oGPE");


var $7zgzO = parcelRequire("7zgzO");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $luv00 = parcelRequire("luv00");

/**
 * @generated SignedSource<<680452723c3681ef8ecd9f974e0c7b70>>
 * @relayHash 45ca605be8de33095ebc20743962c43e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3bbcba102a7657676ea841184f6b31b4f0ab5cf41e8845fb7e0cd397cca8989
const $95874f9a5dd19291$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "editGroupStart"
    }, v3 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "editUserStart"
    }, v4 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "readGroupStart"
    }, v5 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "readUserStart"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v9 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "count"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v15 = [
        v11 /*: any*/ ,
        {
            "concreteType": "UserWithRestrictions",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v10 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "profilePicture",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceViewPermission"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceEditPermission"
                },
                v13 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "restrictingContent",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "base"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        v14 /*: any*/ 
    ], v16 = [
        v11 /*: any*/ ,
        {
            "concreteType": "Group",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v7 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                v13 /*: any*/ 
            ]
        },
        v14 /*: any*/ 
    ], v17 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v10 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentRestrictions",
                            "kind": "LinkedField",
                            "name": "restrictions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentRestriction",
                                    "kind": "LinkedField",
                                    "name": "read",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SubjectsByType",
                                            "kind": "LinkedField",
                                            "name": "restrictions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "start",
                                                            "variableName": "readUserStart"
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedUserWithRestrictions",
                                                    "kind": "LinkedField",
                                                    "name": "userWithRestrictions",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "start",
                                                            "variableName": "readGroupStart"
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedGroupList",
                                                    "kind": "LinkedField",
                                                    "name": "group",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentRestriction",
                                    "kind": "LinkedField",
                                    "name": "update",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SubjectsByType",
                                            "kind": "LinkedField",
                                            "name": "restrictions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "start",
                                                            "variableName": "editUserStart"
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedUserWithRestrictions",
                                                    "kind": "LinkedField",
                                                    "name": "userWithRestrictions",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "start",
                                                            "variableName": "editGroupStart"
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedGroupList",
                                                    "kind": "LinkedField",
                                                    "name": "group",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "containsExternalCollaborators"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "externalCollaboratorCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "alias": "tenant",
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RestrictionsDialogQuery",
            "selections": v17 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RestrictionsDialogQuery",
            "selections": v17 /*: any*/ 
        },
        "params": {
            "cacheID": "45ca605be8de33095ebc20743962c43e",
            "id": "d3bbcba102a7657676ea841184f6b31b4f0ab5cf41e8845fb7e0cd397cca8989",
            "metadata": {},
            "name": "RestrictionsDialogQuery",
            "operationKind": "query",
            "text": "query RestrictionsDialogQuery($contentId:ID!,$status:[String],$draftShareId:String,$readUserStart:Int=0,$readGroupStart:Int=0,$editUserStart:Int=0,$editGroupStart:Int=0){content(id:$contentId,status:$status,draftShareId:$draftShareId){nodes{id,ancestors{id,hasViewRestrictions,links{webui}},hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title,type,status,subType,operations{operation,targetType},restrictions{read{restrictions{userWithRestrictions(start:$readUserStart){count,nodes{type,displayName,accountId,profilePicture{path},hasSpaceViewPermission,hasSpaceEditPermission,permissionType,restrictingContent{id,links{webui,base}}},pageInfo{hasNextPage,endCursor}},group(start:$readGroupStart){count,nodes{id,name,permissionType},pageInfo{hasNextPage,endCursor}}}},update{restrictions{userWithRestrictions(start:$editUserStart){count,nodes{type,displayName,accountId,profilePicture{path},hasSpaceViewPermission,hasSpaceEditPermission,permissionType,restrictingContent{id,links{webui,base}}},pageInfo{hasNextPage,endCursor}},group(start:$editGroupStart){count,nodes{id,name,permissionType},pageInfo{hasNextPage,endCursor}}}}},space{id,containsExternalCollaborators,externalCollaboratorCount}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}},tenant:confluence_tenantContext{editions{confluence}}}"
        }
    };
}();
$95874f9a5dd19291$var$node.hash = "3386190526287a72d54803b61082eb40";
var $95874f9a5dd19291$export$2e2bcd8739ae039 = $95874f9a5dd19291$var$node;


const $10293139900c2f2d$export$840aea712ef7b5d = (0, $95874f9a5dd19291$export$2e2bcd8739ae039);



var $fG32j = parcelRequire("fG32j");


var $7Sm4c = parcelRequire("7Sm4c");





var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $kVysQ = parcelRequire("kVysQ");


var $4NX9d = parcelRequire("4NX9d");


var $6CEg5 = parcelRequire("6CEg5");


var $kvJHJ = parcelRequire("kvJHJ");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $5ZqQS = parcelRequire("5ZqQS");


var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");


var $j7B9O = parcelRequire("j7B9O");


var $lkcsM = parcelRequire("lkcsM");


var $56QzY = parcelRequire("56QzY");


var $c0rhi = parcelRequire("c0rhi");


var $euozR = parcelRequire("euozR");


var $de2j9 = parcelRequire("de2j9");











var $hvS6g = parcelRequire("hvS6g");





var $gmWjz = parcelRequire("gmWjz");


var $i1Dx5 = parcelRequire("i1Dx5");


var $ENihE = parcelRequire("ENihE");

const $a3cf2805f6031e41$var$canRetainNavigation = (reference, environment, variables)=>reference && !reference.disposed && reference.environment === environment && reference.variables.spaceKey === variables.spaceKey && reference.variables.cloudId === variables.cloudId && reference.variables.isLicensed === variables.isLicensed && (reference.variables.includePersistentInviteLicense ?? false) === (variables.includePersistentInviteLicense ?? false);
const $a3cf2805f6031e41$export$103e34b2c9fc8883 = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { environment: environment, variables: variables, fallback: fallback, children: children } = t0;
    const [loaded, setLoaded] = (0, $cozmU.useState)();
    let t1;
    if ($[0] !== environment || $[1] !== variables) {
        t1 = (0, $i1Dx5.getSpaceNavigationQueryOwner)(environment)?.get(variables);
        $[0] = environment;
        $[1] = variables;
        $[2] = t1;
    } else t1 = $[2];
    const prepared = t1;
    let t2;
    if ($[3] !== environment || $[4] !== loaded || $[5] !== prepared || $[6] !== variables) {
        t2 = prepared ?? ($a3cf2805f6031e41$var$canRetainNavigation(loaded, environment, variables) ? loaded : undefined);
        $[3] = environment;
        $[4] = loaded;
        $[5] = prepared;
        $[6] = variables;
        $[7] = t2;
    } else t2 = $[7];
    const requested = t2;
    const deferred = (0, $cozmU.useDeferredValue)(requested);
    let t3;
    if ($[8] !== deferred || $[9] !== environment || $[10] !== requested || $[11] !== variables) {
        t3 = $a3cf2805f6031e41$var$canRetainNavigation(deferred, environment, variables) ? deferred : requested;
        $[8] = deferred;
        $[9] = environment;
        $[10] = requested;
        $[11] = variables;
        $[12] = t3;
    } else t3 = $[12];
    const displayed = t3;
    let t4;
    let t5;
    if ($[13] !== environment || $[14] !== variables) {
        t4 = ()=>{
            const owner = (0, $i1Dx5.getOrCreateSpaceNavigationQueryOwner)(environment);
            const reference = owner.get(variables) ?? owner.preload(variables);
            const release = owner.retain(reference);
            (0, $cozmU.startTransition)(()=>setLoaded(reference));
            return release;
        };
        t5 = [
            environment,
            variables
        ];
        $[13] = environment;
        $[14] = variables;
        $[15] = t4;
        $[16] = t5;
    } else {
        t4 = $[15];
        t5 = $[16];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[17] !== displayed || $[18] !== environment) {
        t6 = ()=>{
            if (displayed) return (0, $i1Dx5.getSpaceNavigationQueryOwner)(environment)?.retain(displayed);
        };
        t7 = [
            environment,
            displayed
        ];
        $[17] = displayed;
        $[18] = environment;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $cozmU.useEffect)(t6, t7);
    const t8 = `${variables.cloudId}:${variables.spaceKey}:${variables.isLicensed}:${variables.includePersistentInviteLicense ?? false}`;
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        });
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== children || $[23] !== displayed || $[24] !== fallback) {
        t10 = displayed && !displayed.disposed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a3cf2805f6031e41$var$QueryReferenceReader, {
            reference: displayed
        }, children) : fallback;
        $[22] = children;
        $[23] = displayed;
        $[24] = fallback;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10 || $[27] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
            key: t8,
            interactionName: "SpaceNavigationQueryOwner",
            fallback: t9
        }, t10);
        $[26] = t10;
        $[27] = t8;
        $[28] = t11;
    } else t11 = $[28];
    return t11;
};
const $a3cf2805f6031e41$var$QueryReferenceReader = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { reference: reference, children: children } = t0;
    if (reference.failed) {
        let t1;
        if ($[0] !== children || $[1] !== reference.error || $[2] !== reference.variables) {
            t1 = children({
                error: reference.error,
                variables: reference.variables
            });
            $[0] = children;
            $[1] = reference.error;
            $[2] = reference.variables;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
            $[4] = t1;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    let t1;
    if ($[6] !== children || $[7] !== reference) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a3cf2805f6031e41$var$PreloadedNavigation, {
            reference: reference
        }, children);
        $[6] = children;
        $[7] = reference;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
};
const $a3cf2805f6031e41$var$PreloadedNavigation = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { reference: reference, children: children } = t0;
    const data = (0, $6SsN4.usePreloadedQuery)((0, $dGmBZ.default), reference.reference);
    let t1;
    if ($[0] !== data || $[1] !== reference.variables) {
        t1 = {
            data: data,
            variables: reference.variables
        };
        $[0] = data;
        $[1] = reference.variables;
        $[2] = t1;
    } else t1 = $[2];
    const context = t1;
    let t2;
    if ($[3] !== children || $[4] !== context || $[5] !== reference.error) {
        t2 = children({
            ...context,
            error: reference.error
        });
        $[3] = children;
        $[4] = context;
        $[5] = reference.error;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== context || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmWjz.SpaceNavigationQueryContext).Provider, {
            value: context
        }, t2);
        $[7] = context;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};


























/**
 * @generated SignedSource<<40f15aa7638ad06f4b52fa8929e5405c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $10cfef4c9a0273b5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeSpaceTypeSettings"
            }
        ],
        "kind": "Fragment",
        "name": "SpaceDetail_space",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "dataClassificationTags"
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    v1 /*: any*/ 
                ]
            },
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            },
            {
                "condition": "includeSpaceTypeSettings",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceTypeSettings",
                        "kind": "LinkedField",
                        "name": "spaceTypeSettings",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "EnabledContentTypes",
                                "kind": "LinkedField",
                                "name": "enabledContentTypes",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isLivePagesEnabled"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isWhiteboardsEnabled"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDatabasesEnabled"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSlidesEnabled"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Space"
    };
}();
$10cfef4c9a0273b5$var$node.hash = "eba0e6a9e61153ecb445e3b3118dc653";
var $10cfef4c9a0273b5$export$2e2bcd8739ae039 = $10cfef4c9a0273b5$var$node;


const $683d1134e7d10071$export$872cafc85037c08d = (0, $10cfef4c9a0273b5$export$2e2bcd8739ae039);



var $89u2G = parcelRequire("89u2G");

const $549a2aa13cb21b4d$export$63b31887d8275b45 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, spaceKey: spaceKey, loading: loading, spaceFragmentRef: spaceFragmentRef } = t0;
    const space = (0, $6SsN4.useFragment)((0, $683d1134e7d10071$export$872cafc85037c08d), spaceFragmentRef);
    let t1;
    if ($[0] !== loading || $[1] !== space || $[2] !== spaceKey) {
        t1 = loading || space?.id && (space.key === spaceKey || space.alias === spaceKey) ? {
            spaceKey: spaceKey,
            loading: loading,
            space: space ?? undefined
        } : undefined;
        $[0] = loading;
        $[1] = space;
        $[2] = spaceKey;
        $[3] = t1;
    } else t1 = $[3];
    const value = t1;
    let t2;
    if ($[4] !== children || $[5] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $89u2G.SpaceDetailContext).Provider, {
            value: value
        }, children);
        $[4] = children;
        $[5] = value;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};











const $1d8862a5b4de55d8$var$SharedSpaceData = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const owned = (0, $gmWjz.useSpaceNavigationQueryData)();
    let t0;
    if ($[0] !== owned || $[1] !== props) {
        t0 = owned && owned.variables === props.variables ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d8862a5b4de55d8$var$SharedSpaceDataResult, {
            ...props,
            data: owned.data
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d8862a5b4de55d8$var$LegacySharedSpaceData, props);
        $[0] = owned;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $1d8862a5b4de55d8$var$LegacySharedSpaceData = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            fetchPolicy: "store-only"
        };
        $[0] = t0;
    } else t0 = $[0];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $dGmBZ.default), props.variables, t0);
    let t1;
    if ($[1] !== data || $[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d8862a5b4de55d8$var$SharedSpaceDataResult, {
            ...props,
            data: data
        });
        $[1] = data;
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
const $1d8862a5b4de55d8$var$SharedSpaceDataResult = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, variables: variables, loading: loading, hasError: hasError, data: data } = t0;
    const t1 = loading && !hasError;
    const t2 = !loading && !hasError ? data?.space?.sharedSpaceDetail ?? null : null;
    let t3;
    if ($[0] !== children || $[1] !== t1 || $[2] !== t2 || $[3] !== variables.spaceKey) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $549a2aa13cb21b4d$export$63b31887d8275b45), {
            spaceKey: variables.spaceKey,
            loading: t1,
            spaceFragmentRef: t2
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
        $[3] = variables.spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
const $1d8862a5b4de55d8$export$cbe87e5b96185611 = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $9HB34.getRelayEnvironment)();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
            environment: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
            interactionName: "SpaceNavigationSharedSpaceData",
            fallback: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d8862a5b4de55d8$var$SharedSpaceData, props)));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};



var $aWrnw = parcelRequire("aWrnw");


var $cpa7E = parcelRequire("cpa7E");


var $28oQf = parcelRequire("28oQf");


var $fadJK = parcelRequire("fadJK");

const $bd16611e4da44658$var$SpaceNavigationQuery = (0, $dGmBZ.default);
const $bd16611e4da44658$var$SPACE_NAV_ID = 'app-navigation-space-container';
const $bd16611e4da44658$var$MANAGE_USERS = 'manage_users';
const $bd16611e4da44658$var$MANAGE_NONLICENSED_USERS = 'manage_nonlicensed_users';
const $bd16611e4da44658$var$MANAGE_GUEST_USERS = 'manage_guest_users';
const $bd16611e4da44658$var$ARCHIVE = 'archive';
const $bd16611e4da44658$var$ADMINISTER = 'administer';
const $bd16611e4da44658$var$MANAGE_CONTENT = 'manage_content';
const $bd16611e4da44658$var$MANAGE_PUBLIC_LINKS = 'manage_public_links';
const $bd16611e4da44658$var$VIEW_ANALYTICS = 'view_analytics';
const $bd16611e4da44658$var$spaceNavigationContainerStyles = null;
const $bd16611e4da44658$var$SpaceNavigationContainer = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { "data-testid": testId, "data-vc": dataVc, "data-ssr-placeholder-replace": dataSSRPlaceholderReplace, onMouseEnter: onMouseEnter, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataSSRPlaceholderReplace || $[3] !== dataVc || $[4] !== onMouseEnter || $[5] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            "data-vc": dataVc,
            "data-ssr-placeholder-replace": dataSSRPlaceholderReplace,
            onMouseEnter: onMouseEnter,
            onFocus: onMouseEnter,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataSSRPlaceholderReplace;
        $[3] = dataVc;
        $[4] = onMouseEnter;
        $[5] = testId;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $bd16611e4da44658$var$REMOTE_OBJECT_SUGGESTION_COUNT_FIELD = 'confluence_remoteObjectSuggestionCount';
function $bd16611e4da44658$export$72974d6ca4f6c884(error) {
    const graphQLErrors = error.graphQLErrors;
    if (!graphQLErrors || graphQLErrors.length === 0) return false;
    return graphQLErrors.every(({ path: path })=>Array.isArray(path) && path.includes($bd16611e4da44658$var$REMOTE_OBJECT_SUGGESTION_COUNT_FIELD));
} // Content-type settings are non-nullable. Their separate space alias prevents a settings
// failure from nulling the core navigation space in the same GraphQL response.
function $bd16611e4da44658$var$isOnlyCreationEligibilityError(error) {
    return !error.networkError && Boolean(error.graphQLErrors?.length) && error.graphQLErrors.every(({ path: path })=>Array.isArray(path) && path[0] === 'creationEligibilitySpace');
} // These fields belong to optional affordances, not to space-access or navigation eligibility.
function $bd16611e4da44658$export$6cf9339ada77bc2(error) {
    return !error.networkError && Boolean(error.graphQLErrors?.length) && error.graphQLErrors.every(({ path: path })=>Array.isArray(path) && (path[0] === $bd16611e4da44658$var$REMOTE_OBJECT_SUGGESTION_COUNT_FIELD || path[0] === 'license' && (path.length === 1 || path.length === 2 && (path[1] === 'licenseConsumingUserCount' || path[1] === 'trialEndDate'))));
}
function $bd16611e4da44658$export$cf79402712cc318a(error) {
    const graphQLErrors = error.graphQLErrors;
    if (!graphQLErrors || graphQLErrors.length === 0) return false;
    return graphQLErrors.every(({ extensions: extensions })=>{
        const statusCode = extensions?.statusCode;
        return typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500;
    });
}
const $bd16611e4da44658$export$587bdd19f8501571 = (0, $dOBRD.default)((loading, data, error)=>{
    const result = {
        loading: loading,
        hasSpace: false,
        isSpaceAdmin: false,
        canManageSomeUsers: false,
        canManageSettingsAutomation: false,
        canManageContent: false,
        canManagePublicLinks: false,
        canViewAnalytics: false,
        containsExternalCollaborators: false,
        main: [],
        quick: [],
        isUserExternalCollaborator: false,
        hasRestrictedError: false,
        hasNotFoundError: false,
        isSpaceArchived: false,
        hasDeleteSpacePermission: false,
        hasArchiveSpacePermission: false
    };
    if (loading) return result;
    if (error && (!$bd16611e4da44658$export$72974d6ca4f6c884(error) || error.networkError && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_license_error_fix'))) {
        if (data?.space && data.spaceSidebarLinks && ($bd16611e4da44658$export$6cf9339ada77bc2(error) && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_license_error_fix') || $bd16611e4da44658$var$isOnlyCreationEligibilityError(error) && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_creation_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false))) // Preserve navigation while still reporting the optional field failure via ErrorDisplay.
        result.optionalAffordanceError = error;
        else {
            if ((0, $fG32j.isSpaceRestrictedError)(error)) result.hasRestrictedError = true;
            else if ((0, $fG32j.isSpaceNotFoundError)(error)) result.hasNotFoundError = true;
            else result.unhandledError = error;
            return result;
        }
    }
    result.hasSpace = Boolean(data?.space ?? result.hasSpace);
    result.space = data?.space || undefined;
    result.name = data?.space?.name || undefined;
    result.iconPath = `${0, $jlIaF.CONTEXT_PATH}${data?.space?.icon?.path}`;
    result.isSpaceAdmin = data?.space?.currentUser?.isAdmin ?? result.isSpaceAdmin;
    result.canManageSomeUsers = data?.space?.operations?.some((operation)=>operation?.operation === $bd16611e4da44658$var$MANAGE_USERS || operation?.operation === $bd16611e4da44658$var$MANAGE_NONLICENSED_USERS || operation?.operation === $bd16611e4da44658$var$MANAGE_GUEST_USERS) ?? result.canManageSomeUsers;
    result.canManageSettingsAutomation = data?.space?.operations?.some((operation)=>operation?.operation === $bd16611e4da44658$var$ADMINISTER && operation?.targetType === 'space') ?? result.canManageSettingsAutomation;
    result.canManageContent = data?.space?.operations?.some((operation)=>operation?.operation === $bd16611e4da44658$var$MANAGE_CONTENT && operation?.targetType === 'space') ?? result.canManageContent;
    result.canManagePublicLinks = data?.space?.operations?.some((operation)=>operation?.operation === $bd16611e4da44658$var$MANAGE_PUBLIC_LINKS && operation?.targetType === 'space') ?? result.canManagePublicLinks;
    result.canViewAnalytics = data?.space?.operations?.some((operation)=>operation?.operation === $bd16611e4da44658$var$VIEW_ANALYTICS && operation?.targetType === 'space') ?? result.canViewAnalytics;
    result.homepageId = data?.space?.homepage?.id || undefined;
    result.containsExternalCollaborators = data?.space?.containsExternalCollaborators ?? result.containsExternalCollaborators;
    result.main = data?.spaceSidebarLinks?.main?.filter($bd16611e4da44658$var$isNonNullable) ?? result.main;
    result.quick = data?.spaceSidebarLinks?.quick?.filter($bd16611e4da44658$var$isNonNullable) ?? result.quick;
    result.isUserExternalCollaborator = data?.user?.confluence?.permissionType === 'EXTERNAL';
    result.isSpaceArchived = data?.space?.status === 'archived';
    if (data?.space?.operations) {
        result.hasDeleteSpacePermission = data.space.operations?.some((operation)=>operation?.operation === 'delete' && operation?.targetType === 'space');
        result.hasArchiveSpacePermission = data.space.operations?.some((operation)=>operation?.operation === $bd16611e4da44658$var$ARCHIVE && operation?.targetType === 'space');
    }
    return result;
});
const $bd16611e4da44658$var$useSpaceNavigationVariables = (spaceKey, contentId, isBlogNavigation, isBlogTreeInitiallyExpanded, isSpaceOverview)=>{
    const $ = (0, $bDgLe.c)(18);
    const { cloudId: cloudId, edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = (0, $8Lx5S.useIsLicensed)();
    let t0;
    if ($[0] !== edition || $[1] !== hasLicensedAccess || $[2] !== isLicensed || $[3] !== isLoggedIn) {
        t0 = edition !== (0, $euL71.ConfluenceEdition).FREE && isLoggedIn && (!(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_license_error_fix") ? hasLicensedAccess : isLicensed);
        $[0] = edition;
        $[1] = hasLicensedAccess;
        $[2] = isLicensed;
        $[3] = isLoggedIn;
        $[4] = t0;
    } else t0 = $[4];
    const includePersistentInviteLicense = t0;
    const includeHomepageTreeVariant = isSpaceOverview || !contentId || isBlogNavigation;
    let t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_shared_space_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false);
        t2 = !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_creation_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false);
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    let t3;
    if ($[7] !== contentId || $[8] !== includeHomepageTreeVariant || $[9] !== isBlogTreeInitiallyExpanded || $[10] !== isSpaceOverview) {
        t3 = !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_trees_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? {
            contentId: isSpaceOverview ? "" : contentId,
            includeBlogTree: isBlogTreeInitiallyExpanded,
            includeHomepageTreeVariant: includeHomepageTreeVariant,
            includePageTree: !includeHomepageTreeVariant,
            isSuperAdmin: false,
            paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
            ptStatuses: (0, $ivyMZ.PAGE_TREE_STATUSES)
        } : {};
        $[7] = contentId;
        $[8] = includeHomepageTreeVariant;
        $[9] = isBlogTreeInitiallyExpanded;
        $[10] = isSpaceOverview;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== cloudId || $[13] !== includePersistentInviteLicense || $[14] !== isLicensed || $[15] !== spaceKey || $[16] !== t3) {
        t4 = {
            cloudId: cloudId,
            spaceKey: spaceKey,
            isLicensed: isLicensed,
            includePersistentInviteLicense: includePersistentInviteLicense,
            includeSpaceViewsPersistence: isLicensed,
            includeSharedSpaceDetails: t1,
            includeSpaceCreationEligibility: t2,
            ...t3
        };
        $[12] = cloudId;
        $[13] = includePersistentInviteLicense;
        $[14] = isLicensed;
        $[15] = spaceKey;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
};
const $bd16611e4da44658$var$usePreloadSpaceNavigation = (variables, isEditorPage, location)=>{
    const { spaceKey: spaceKey } = variables;
    const queryResult = (0, $jMyy4.useQueryInterop)($bd16611e4da44658$var$SpaceNavigationQuery, {
        errorPolicy: 'all',
        variables: variables,
        __callerPackage__: "side-navigation"
    });
    const lastSettledTreeQueryRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        if (!queryResult.loading && queryResult.data?.space && (!queryResult.error || $bd16611e4da44658$export$72974d6ca4f6c884(queryResult.error) && (!queryResult.error.networkError || (0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_license_error_fix')) || queryResult.data.spaceSidebarLinks && ($bd16611e4da44658$export$6cf9339ada77bc2(queryResult.error) && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_license_error_fix') || $bd16611e4da44658$var$isOnlyCreationEligibilityError(queryResult.error) && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_creation_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false)))) lastSettledTreeQueryRef.current = queryResult;
    }, [
        queryResult
    ]);
    const { loading: loading, data: data, error: error, variables: routeReaderVariables } = queryResult.loading && lastSettledTreeQueryRef.current?.variables.spaceKey === spaceKey && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_trees_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false) ? {
        ...lastSettledTreeQueryRef.current,
        error: undefined
    } : queryResult;
    return $bd16611e4da44658$var$getNavigationResult({
        loading: loading,
        data: data,
        error: error,
        variables: routeReaderVariables
    }, isEditorPage, location);
};
const $bd16611e4da44658$var$getNavigationResult = ({ loading: loading, data: data, error: error, variables: routeReaderVariables }, isEditorPage, location)=>{
    const { spaceKey: spaceKey } = routeReaderVariables;
    const result = $bd16611e4da44658$export$587bdd19f8501571(loading, data, error);
    const isEmbeddedRovoSystemSpaceAllowed = (0, $gAcLU.isEmbeddedRovoSystemSpaceAccessAllowed)({
        isEditorPage: isEditorPage,
        location: location
    });
    if ((0, $8Psje.isRovoSystemSpaceKey)(spaceKey) && !isEmbeddedRovoSystemSpaceAllowed) result.hasNotFoundError = true;
    if (loading) return {
        ...result,
        routeReaderVariables: routeReaderVariables,
        hasSpaceDetailError: Boolean(error)
    };
    if (error) {
        if ((0, $fG32j.isSpaceRestrictedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else if ((0, $fG32j.isSpaceNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else if ($bd16611e4da44658$export$72974d6ca4f6c884(error) && $bd16611e4da44658$export$cf79402712cc318a(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return {
        ...result,
        routeReaderVariables: routeReaderVariables,
        hasSpaceDetailError: Boolean(error)
    };
};
const $bd16611e4da44658$var$useOldRestrictionsButtonRefetch = ()=>{
    const refetch = $bd16611e4da44658$var$_temp;
    return refetch;
};
const $bd16611e4da44658$export$a91923d0186f609a = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const $ = (0, $bDgLe.c)(25);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [t0] = (0, $ep3mz.usePageState)();
    const { contentId: contentId } = t0;
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const t1 = !props.isBlogNavigation;
    const t2 = Boolean(props.isBlogNavigation);
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            sectionName: "blogTree",
            collapsedByDefault: t1,
            forceExpand: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const { isExpanded: isBlogTreeInitiallyExpanded } = (0, $j3kZx.useSpacePersistentExpansion)(t3);
    const isContentArchived = (0, $j7B9O.useIsContentArchived)(contentId);
    let t4;
    if ($[3] !== isContentArchived || $[4] !== location) {
        t4 = Boolean(location && (0, $1NBp8.SPACE_OVERVIEW).match(location.pathname)) || isContentArchived;
        $[3] = isContentArchived;
        $[4] = location;
        $[5] = t4;
    } else t4 = $[5];
    const variables = $bd16611e4da44658$var$useSpaceNavigationVariables(spaceKey ?? "", contentId, Boolean(props.isBlogNavigation), isBlogTreeInitiallyExpanded, t4);
    if (!(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_preloaded_query") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false)) {
        let t5;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = (0, $9HB34.getRelayEnvironment)();
            $[6] = t5;
        } else t5 = $[6];
        const environment = t5;
        let t6;
        if ($[7] !== isOnEditRoute || $[8] !== location || $[9] !== props || $[10] !== variables) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd16611e4da44658$var$LegacySpaceNavigation, {
                ...props,
                variables: variables,
                isOnEditRoute: isOnEditRoute,
                routeLocation: location
            });
            $[7] = isOnEditRoute;
            $[8] = location;
            $[9] = props;
            $[10] = variables;
            $[11] = t6;
        } else t6 = $[11];
        let t7;
        if ($[12] !== isOnEditRoute || $[13] !== location || $[14] !== props) {
            t7 = (result)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd16611e4da44658$var$SpaceNavigationWithData, {
                    ...props,
                    navigationData: $bd16611e4da44658$var$getNavigationResult({
                        ...result,
                        loading: false
                    }, isOnEditRoute, location)
                });
            $[12] = isOnEditRoute;
            $[13] = location;
            $[14] = props;
            $[15] = t7;
        } else t7 = $[15];
        let t8;
        if ($[16] !== t6 || $[17] !== t7 || $[18] !== variables) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
                environment: environment
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a3cf2805f6031e41$export$103e34b2c9fc8883), {
                environment: environment,
                variables: variables,
                fallback: t6
            }, t7));
            $[16] = t6;
            $[17] = t7;
            $[18] = variables;
            $[19] = t8;
        } else t8 = $[19];
        return t8;
    }
    let t5;
    if ($[20] !== isOnEditRoute || $[21] !== location || $[22] !== props || $[23] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd16611e4da44658$var$LegacySpaceNavigation, {
            ...props,
            variables: variables,
            isOnEditRoute: isOnEditRoute,
            routeLocation: location
        });
        $[20] = isOnEditRoute;
        $[21] = location;
        $[22] = props;
        $[23] = variables;
        $[24] = t5;
    } else t5 = $[24];
    return t5;
});
const $bd16611e4da44658$var$LegacySpaceNavigation = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let isOnEditRoute;
    let props;
    let routeLocation;
    let variables;
    if ($[0] !== t0) {
        ({ variables: variables, isOnEditRoute: isOnEditRoute, routeLocation: routeLocation, ...props } = t0);
        $[0] = t0;
        $[1] = isOnEditRoute;
        $[2] = props;
        $[3] = routeLocation;
        $[4] = variables;
    } else {
        isOnEditRoute = $[1];
        props = $[2];
        routeLocation = $[3];
        variables = $[4];
    }
    const navigationData = $bd16611e4da44658$var$usePreloadSpaceNavigation(variables, isOnEditRoute, routeLocation);
    let t1;
    if ($[5] !== navigationData || $[6] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd16611e4da44658$var$SpaceNavigationWithData, {
            ...props,
            navigationData: navigationData
        });
        $[5] = navigationData;
        $[6] = props;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
const $bd16611e4da44658$var$SpaceNavigationWithData = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let navigationData;
    let props;
    if ($[0] !== t0) {
        ({ navigationData: navigationData, ...props } = t0);
        $[0] = t0;
        $[1] = navigationData;
        $[2] = props;
    } else {
        navigationData = $[1];
        props = $[2];
    }
    const spaceKey = navigationData.routeReaderVariables.spaceKey;
    let t1;
    if ($[3] !== navigationData || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd16611e4da44658$var$SpaceNavigationInner, {
            ...props,
            navigationData: navigationData
        });
        $[3] = navigationData;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const content = t1;
    let t2;
    if ($[6] !== content || $[7] !== navigationData.hasSpaceDetailError || $[8] !== navigationData.loading || $[9] !== navigationData.routeReaderVariables || $[10] !== spaceKey) {
        t2 = spaceKey && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_shared_space_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d8862a5b4de55d8$export$cbe87e5b96185611), {
            variables: navigationData.routeReaderVariables,
            loading: navigationData.loading,
            hasError: navigationData.hasSpaceDetailError
        }, content) : content;
        $[6] = content;
        $[7] = navigationData.hasSpaceDetailError;
        $[8] = navigationData.loading;
        $[9] = navigationData.routeReaderVariables;
        $[10] = spaceKey;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
const $bd16611e4da44658$var$SpaceNavigationInner = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(92);
    const { isBlogNavigation: isBlogNavigation, isSpaceSettingsScreen: t1, navigationData: navigationData } = t0;
    t1 === undefined || t1;
    const [pageTreeFinishedLoading, setPageTreeFinishedLoading] = (0, $cozmU.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isEditorOpen = (0, $euozR.useIsEditorOpen)();
    const spaceKey = stateSpaceKey;
    const { push: push, match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const onDragDropSuccess = $bd16611e4da44658$var$useOldRestrictionsButtonRefetch();
    let t2;
    if ($[0] !== push || $[1] !== spaceKey) {
        t2 = ()=>{
            push(`/wiki/spaces/${spaceKey}/overview`);
        };
        $[0] = push;
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    const onOverviewShortcutTrigger = t2;
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== match?.name) {
        t3 = ()=>{
            (0, $68460bd0ab58b973$export$2e2bcd8739ae039)("space-navigation-hover");
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "entered",
                    actionSubject: "spaceNavigation",
                    source: match?.name,
                    attributes: {
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = match?.name;
        $[5] = t3;
    } else t3 = $[5];
    const handleMouseEnter = t3;
    const { loading: loading, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, unhandledError: unhandledError, optionalAffordanceError: optionalAffordanceError, hasSpace: hasSpace, name: name, space: space, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, canManageSettingsAutomation: canManageSettingsAutomation, canManageContent: canManageContent, canManagePublicLinks: canManagePublicLinks, canViewAnalytics: canViewAnalytics, homepageId: homepageId, containsExternalCollaborators: containsExternalCollaborators, main: main, quick: quick, isUserExternalCollaborator: isUserExternalCollaborator, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission, routeReaderVariables: routeReaderVariables } = navigationData;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            moduleType: (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE),
            spaceContextOnly: true
        };
        $[6] = t4;
    } else t4 = $[6];
    const { loading: loadingForgeApps, extensions: forgeApps, error: forgeError } = (0, $3b6WO.useExtensionList)(t4);
    if (forgeError && !(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError)) {
        (0, $5ZqQS.getMonitoringClient)().submitError(forgeError, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(forgeError);
    }
    let t5;
    if ($[7] !== forgeApps || $[8] !== isSpaceAdmin || $[9] !== main || $[10] !== spaceKey) {
        t5 = (0, $cpa7E.getAllAppLinks)(spaceKey, main, forgeApps, isSpaceAdmin);
        $[7] = forgeApps;
        $[8] = isSpaceAdmin;
        $[9] = main;
        $[10] = spaceKey;
        $[11] = t5;
    } else t5 = $[11];
    const { allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, shouldRenderSpaceApps: shouldRenderSpaceApps } = t5;
    let t6;
    if ($[12] !== main) {
        t6 = main.filter($bd16611e4da44658$var$_temp2);
        $[12] = main;
        $[13] = t6;
    } else t6 = $[13];
    const shortcutsHidden = t6.length > 0;
    let t7;
    if ($[14] !== main) {
        t7 = main.find($bd16611e4da44658$var$_temp3);
        $[14] = main;
        $[15] = t7;
    } else t7 = $[15];
    const blogsWebItem = t7;
    const blogsHidden = !blogsWebItem || blogsWebItem.hidden === true;
    const showShortcutsSection = !loading && !shortcutsHidden;
    let t8;
    if ($[16] !== blogsHidden || $[17] !== main || $[18] !== showShortcutsSection) {
        t8 = {
            showShortcutsSection: showShortcutsSection,
            blogsHidden: blogsHidden,
            main: main
        };
        $[16] = blogsHidden;
        $[17] = main;
        $[18] = showShortcutsSection;
        $[19] = t8;
    } else t8 = $[19];
    const visibility = t8;
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            setPageTreeFinishedLoading(true);
        };
        $[20] = t9;
    } else t9 = $[20];
    const onContentTreeLoadComplete = t9;
    const spaceId = space?.id || "";
    const spaceName = name || "";
    const isStarred = Boolean(space?.currentUser?.isFavourited);
    const isWatched = Boolean(space?.currentUser?.isWatched);
    let t10;
    if ($[21] !== allAppLinks || $[22] !== allVisibleAppLinks || $[23] !== canManageSomeUsers || $[24] !== hasSpace || $[25] !== homepageId || $[26] !== isBlogNavigation || $[27] !== isSpaceAdmin || $[28] !== loading || $[29] !== loadingForgeApps || $[30] !== onDragDropSuccess || $[31] !== pageTreeFinishedLoading || $[32] !== quick || $[33] !== routeReaderVariables || $[34] !== shouldRenderSpaceApps || $[35] !== space || $[36] !== spaceKey || $[37] !== visibility.blogsHidden || $[38] !== visibility.main || $[39] !== visibility.showShortcutsSection) {
        t10 = {
            loading: loading,
            hasSpace: hasSpace,
            space: space,
            spaceKey: spaceKey,
            homepageId: homepageId,
            main: visibility.main,
            quick: quick,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: visibility.blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            showShortcutsSection: visibility.showShortcutsSection,
            shouldRenderSpaceApps: shouldRenderSpaceApps,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks,
            loadingForgeApps: loadingForgeApps,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            routeReaderVariables: routeReaderVariables
        };
        $[21] = allAppLinks;
        $[22] = allVisibleAppLinks;
        $[23] = canManageSomeUsers;
        $[24] = hasSpace;
        $[25] = homepageId;
        $[26] = isBlogNavigation;
        $[27] = isSpaceAdmin;
        $[28] = loading;
        $[29] = loadingForgeApps;
        $[30] = onDragDropSuccess;
        $[31] = pageTreeFinishedLoading;
        $[32] = quick;
        $[33] = routeReaderVariables;
        $[34] = shouldRenderSpaceApps;
        $[35] = space;
        $[36] = spaceKey;
        $[37] = visibility.blogsHidden;
        $[38] = visibility.main;
        $[39] = visibility.showShortcutsSection;
        $[40] = t10;
    } else t10 = $[40];
    const navigationProps = t10;
    let t11;
    if ($[41] !== hasNotFoundError || $[42] !== hasRestrictedError || $[43] !== unhandledError) {
        t11 = {
            unhandledError: unhandledError,
            hasRestrictedError: hasRestrictedError,
            hasNotFoundError: hasNotFoundError
        };
        $[41] = hasNotFoundError;
        $[42] = hasRestrictedError;
        $[43] = unhandledError;
        $[44] = t11;
    } else t11 = $[44];
    const errorProps = t11;
    const t12 = space?.type === "personal";
    let t13;
    if ($[45] !== canManageContent || $[46] !== canManagePublicLinks || $[47] !== canManageSettingsAutomation || $[48] !== canManageSomeUsers || $[49] !== canViewAnalytics || $[50] !== containsExternalCollaborators || $[51] !== hasArchiveSpacePermission || $[52] !== hasDeleteSpacePermission || $[53] !== homepageId || $[54] !== iconPath || $[55] !== isSpaceAdmin || $[56] !== isSpaceArchived || $[57] !== isStarred || $[58] !== isUserExternalCollaborator || $[59] !== isWatched || $[60] !== spaceId || $[61] !== spaceKey || $[62] !== spaceName || $[63] !== t12) {
        t13 = {
            spaceId: spaceId,
            spaceName: spaceName,
            spaceKey: spaceKey,
            homepageId: homepageId,
            iconPath: iconPath,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            canManageSettingsAutomation: canManageSettingsAutomation,
            canManageContent: canManageContent,
            canManagePublicLinks: canManagePublicLinks,
            canViewAnalytics: canViewAnalytics,
            isPersonalSpace: t12,
            containsExternalCollaborators: containsExternalCollaborators,
            isExternalCollaborator: isUserExternalCollaborator,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        };
        $[45] = canManageContent;
        $[46] = canManagePublicLinks;
        $[47] = canManageSettingsAutomation;
        $[48] = canManageSomeUsers;
        $[49] = canViewAnalytics;
        $[50] = containsExternalCollaborators;
        $[51] = hasArchiveSpacePermission;
        $[52] = hasDeleteSpacePermission;
        $[53] = homepageId;
        $[54] = iconPath;
        $[55] = isSpaceAdmin;
        $[56] = isSpaceArchived;
        $[57] = isStarred;
        $[58] = isUserExternalCollaborator;
        $[59] = isWatched;
        $[60] = spaceId;
        $[61] = spaceKey;
        $[62] = spaceName;
        $[63] = t12;
        $[64] = t13;
    } else t13 = $[64];
    const spaceDetails = t13;
    let t14;
    if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: "SpaceViewLoading"
        });
        $[65] = t14;
    } else t14 = $[65];
    let t15;
    if ($[66] !== errorProps || $[67] !== hasSpace || $[68] !== loading || $[69] !== navigationProps || $[70] !== spaceDetails) {
        t15 = !loading && hasSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fadJK.SpaceNavigationContent), {
            navigationProps: navigationProps,
            errorProps: errorProps,
            spaceDetails: spaceDetails
        }));
        $[66] = errorProps;
        $[67] = hasSpace;
        $[68] = loading;
        $[69] = navigationProps;
        $[70] = spaceDetails;
        $[71] = t15;
    } else t15 = $[71];
    const t16 = !isEditorOpen ? (0, $gnkil.SPACE_OVERVIEW_SHORTCUT) : undefined;
    let t17;
    if ($[72] !== onOverviewShortcutTrigger || $[73] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            key: "overview-shortcut",
            deprecatedAccelerator: t16,
            accelerator: (0, $gnkil.UNIVERSAL_SPACE_OVERVIEW_SHORTCUT),
            listener: onOverviewShortcutTrigger
        });
        $[72] = onOverviewShortcutTrigger;
        $[73] = t16;
        $[74] = t17;
    } else t17 = $[74];
    let t18;
    if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NX9d.PerformanceEnd), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_sideNavigationFMP),
            subjectId: "SideNavigationFMP",
            includeFeatureFlags: true
        });
        $[75] = t18;
    } else t18 = $[75];
    let t19;
    if ($[76] !== loading || $[77] !== spaceKey) {
        t19 = !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: spaceKey,
            metric: (0, $aWrnw.SPACE_NAVIGATION_METRIC)
        });
        $[76] = loading;
        $[77] = spaceKey;
        $[78] = t19;
    } else t19 = $[78];
    let t20;
    if ($[79] !== unhandledError) {
        t20 = unhandledError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: unhandledError
        });
        $[79] = unhandledError;
        $[80] = t20;
    } else t20 = $[80];
    let t21;
    if ($[81] !== optionalAffordanceError) {
        t21 = optionalAffordanceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: optionalAffordanceError
        });
        $[81] = optionalAffordanceError;
        $[82] = t21;
    } else t21 = $[82];
    let t22;
    if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = window.__SSR_RENDERED__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkcsM.FocusToCurrentPageTreeLinkItemSSRInlineScript), null);
        $[83] = t22;
    } else t22 = $[83];
    let t23;
    if ($[84] !== handleMouseEnter || $[85] !== ssrPlaceholderIdProp || $[86] !== t15 || $[87] !== t17 || $[88] !== t19 || $[89] !== t20 || $[90] !== t21) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd16611e4da44658$var$SpaceNavigationContainer, {
            "data-testid": $bd16611e4da44658$var$SPACE_NAV_ID,
            "data-vc": "space-navigation",
            onMouseEnter: handleMouseEnter,
            ...ssrPlaceholderIdProp
        }, t14, t15, t17, t18, t19, t20, t21, t22));
        $[84] = handleMouseEnter;
        $[85] = ssrPlaceholderIdProp;
        $[86] = t15;
        $[87] = t17;
        $[88] = t19;
        $[89] = t20;
        $[90] = t21;
        $[91] = t23;
    } else t23 = $[91];
    return t23;
});
function $bd16611e4da44658$var$isNonNullable(x) {
    return Boolean(x);
}
function $bd16611e4da44658$var$_temp(contentId) {
    (0, $c0rhi.queryInterop)({
        query: (0, $10293139900c2f2d$export$840aea712ef7b5d),
        variables: {
            contentId: contentId
        },
        fetchPolicy: "network-only",
        __callerPackage__: "side-navigation"
    });
}
function $bd16611e4da44658$var$_temp2(t0) {
    const { webItemCompleteKey: webItemCompleteKey, hidden: hidden } = t0;
    return webItemCompleteKey === (0, $28oQf.SHORTCUTS_KEY) && hidden;
}
function $bd16611e4da44658$var$_temp3(t0) {
    const { webItemCompleteKey: webItemCompleteKey_0 } = t0;
    return webItemCompleteKey_0 === (0, $28oQf.BLOG_KEY);
}
module.exports["isOnlyRemoteObjectSuggestionCountError"] = $bd16611e4da44658$export$72974d6ca4f6c884;
module.exports["isOnlyOptionalAffordanceError"] = $bd16611e4da44658$export$6cf9339ada77bc2;
module.exports["isExpectedSuggestionCountError"] = $bd16611e4da44658$export$cf79402712cc318a;
module.exports["createResult"] = $bd16611e4da44658$export$587bdd19f8501571;
module.exports["SpaceNavigation"] = $bd16611e4da44658$export$a91923d0186f609a;

});

parcelRegister("gAcLU", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $9wGTI = parcelRequire("9wGTI");

const $162d85f7d3762fcf$export$4ac233f7b686bff9 = 'allowRovoSystemSpace';
const $162d85f7d3762fcf$export$736f471ffe80ff46 = ({ isEditorPage: isEditorPage, location: location })=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (isEditorPage || !location || !(0, $9wGTI.fg)('confluence_frontend_allow_embedded_rovo_space_view')) return false;
    const locationWithSearch = {
        search: location.search ?? ''
    };
    if (!(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(locationWithSearch)) return false;
    return new URLSearchParams(locationWithSearch.search).has($162d85f7d3762fcf$export$4ac233f7b686bff9);
};
module.exports["isEmbeddedRovoSystemSpaceAccessAllowed"] = $162d85f7d3762fcf$export$736f471ffe80ff46;

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$9df55620e365effa = ()=>{
    const { isLoggedIn: isLoggedIn, hasConfluenceUser: hasConfluenceUser } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && !hasConfluenceUser;
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useIsAuthenticatedWithoutConfluenceUser"] = $30f02aa82d7102bc$export$9df55620e365effa;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("j3kZx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $cozmU.useState)();
    const isDefaultExpanded = (0, $cozmU.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $cozmU.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("aNTfk"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("aNTfk", function(module, exports) {

let $7dd955baed2e25fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7dd955baed2e25fc$var$load("koqDJ"),
    $7dd955baed2e25fc$var$load("hhss7"),
    $7dd955baed2e25fc$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("b3j2Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

function $ff81fbcf85bdaf85$export$d56b0569bceb92ae(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { children: children, error: error } = t0;
    const [errorListenerIsReady, setErrorListenerIsReady] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== error) {
        t1 = ()=>{
            const listener = (event)=>{
                if (event.error === error) event.preventDefault();
            };
            window.addEventListener("error", listener);
            setErrorListenerIsReady(true);
            return ()=>{
                window.removeEventListener("error", listener);
                setErrorListenerIsReady(false);
            };
        };
        t2 = [
            error,
            setErrorListenerIsReady
        ];
        $[0] = error;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    const renderOnError = t3;
    let t4;
    if ($[5] !== error || $[6] !== errorListenerIsReady) {
        t4 = errorListenerIsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff81fbcf85bdaf85$export$4d51f41a5e7cc382, {
            error: error
        }) : null;
        $[5] = error;
        $[6] = errorListenerIsReady;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== renderOnError || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INHERIT,
            renderOnError: renderOnError
        }, t4);
        $[8] = renderOnError;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
}
function $ff81fbcf85bdaf85$export$4d51f41a5e7cc382({ error: error }) {
    throw error;
}
module.exports["ErrorDisplay"] = $ff81fbcf85bdaf85$export$d56b0569bceb92ae;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("6CEg5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $cozmU.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $8W4Gr = parcelRequire("8W4Gr");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    // Capture before onComplete or a deferred paint callback can start another interaction.
    const binding = props.metric ? (0, $8W4Gr.getPageSegmentUFOBinding)(props.metric) : undefined;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        const data = {
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        };
        // An imperative start has no embedded context; retain its captured key and owner.
        if (binding && (binding.key === prefixedKey || binding.key === resolvedKey)) // Preserve React end-mark timing; stopTime is metadata on this API.
        (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, {
            customData: data
        });
        else {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
            (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
            (0, $gXfti.addUFOCustomData)(data);
        }
    }, [
        binding,
        onComplete,
        prefixedKey,
        resolvedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

/**
 * Discovery is filtered by space/page, visibility and context mode, so SSR data
 * (including an empty list) is reusable only for an equivalent request. Space-only
 * requests intentionally ignore contentId. Callers check module eligibility,
 * errors and snapshot lifetime separately.
 */ const $8eb9026be26e0c85$var$matchesExtensionListContext = (preloadedContext, currentContext)=>preloadedContext !== undefined && preloadedContext.spaceKey === currentContext.spaceKey && preloadedContext.includeHidden === currentContext.includeHidden && preloadedContext.spaceContextOnly === currentContext.spaceContextOnly && (currentContext.spaceContextOnly || preloadedContext.contentId === currentContext.contentId);
const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, skipSpaceDetail: t3, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const skipSpaceDetail = t3 === undefined ? false : t3;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    let t4;
    if ($[0] !== skipSpaceDetail) {
        t4 = {
            skip: skipSpaceDetail
        };
        $[0] = skipSpaceDetail;
        $[1] = t4;
    } else t4 = $[1];
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, t4);
    let t5;
    if ($[2] !== moduleType) {
        t5 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[2] = moduleType;
        $[3] = t5;
    } else t5 = $[3];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t5);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    let t6;
    if ($[4] !== isTransition || $[5] !== moduleType || $[6] !== resolvedAttachmentId || $[7] !== skipQuery || $[8] !== ssrExtensionResult) {
        t6 = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition && (0, $6mKj3.expValEquals)("confluence_ssr_forge_page_banner", "isEnabled", true) ? ssrExtensionResult : undefined;
        $[4] = isTransition;
        $[5] = moduleType;
        $[6] = resolvedAttachmentId;
        $[7] = skipQuery;
        $[8] = ssrExtensionResult;
        $[9] = t6;
    } else t6 = $[9];
    const pageBannerSSRResult = t6;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const t7 = skipQuery || preloadedPageBanners !== undefined;
    let t8;
    if ($[10] !== cloudId || $[11] !== contentId || $[12] !== locale || $[13] !== moduleType || $[14] !== queryOptions || $[15] !== resolvedAttachmentId || $[16] !== returnBlockedExtensions || $[17] !== spaceContextOnly || $[18] !== spaceKey || $[19] !== t7) {
        t8 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: t7
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[10] = cloudId;
        $[11] = contentId;
        $[12] = locale;
        $[13] = moduleType;
        $[14] = queryOptions;
        $[15] = resolvedAttachmentId;
        $[16] = returnBlockedExtensions;
        $[17] = spaceContextOnly;
        $[18] = spaceKey;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    const options = t8;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t10;
    let t9;
    if ($[21] !== extsError || $[22] !== spaceError) {
        t9 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t10 = [
            extsError,
            spaceError
        ];
        $[21] = extsError;
        $[22] = spaceError;
        $[23] = t10;
        $[24] = t9;
    } else {
        t10 = $[23];
        t9 = $[24];
    }
    (0, $cozmU.useEffect)(t9, t10);
    if (preloadedPageBanners) {
        let t11;
        if ($[25] !== preloadedPageBanners.extensions) {
            t11 = {
                extensions: preloadedPageBanners.extensions,
                loading: false,
                error: undefined,
                isSSRResult: true
            };
            $[25] = preloadedPageBanners.extensions;
            $[26] = t11;
        } else t11 = $[26];
        return t11;
    }
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
        let t11;
        if ($[27] !== ssrExtensionResult.error || $[28] !== ssrExtensionResult.extensions) {
            t11 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[27] = ssrExtensionResult.error;
            $[28] = ssrExtensionResult.extensions;
            $[29] = t11;
        } else t11 = $[29];
        return t11;
    }
    let t11;
    if ($[30] !== extsData || $[31] !== extsError || $[32] !== extsLoading) {
        t11 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[30] = extsData;
        $[31] = extsError;
        $[32] = extsLoading;
        $[33] = t11;
    } else t11 = $[33];
    return t11;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, skipSpaceDetail: skipSpaceDetail = false, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        skip: skipSpaceDetail
    });
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    // The boot payload belongs to the initial route. Never reuse it after navigation,
    // including when the user returns to the page that originally produced it.
    // Evaluate eligibility before inspecting the payload so control loads are exposed too.
    const pageBannerSSRResult = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition && (0, $6mKj3.expValEquals)('confluence_ssr_forge_page_banner', 'isEnabled', true) ? ssrExtensionResult : undefined;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery || preloadedPageBanners !== undefined
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        preloadedPageBanners,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (preloadedPageBanners) return {
        extensions: preloadedPageBanners.extensions,
        loading: false,
        error: undefined,
        isSSRResult: true
    };
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $89u2G = parcelRequire("89u2G");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(23);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2, skip: t3 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    const skip = t3 === undefined ? false : t3;
    const sharedDetail = (0, $cozmU.useContext)((0, $89u2G.SpaceDetailContext));
    const canUseSharedDetail = Boolean(spaceKey) && sharedDetail?.spaceKey === spaceKey && (!includeSpaceTypeSettings || sharedDetail?.space?.spaceTypeSettings !== undefined);
    let t4;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t4 = {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== canUseSharedDetail || $[6] !== skip) {
        t5 = skip || canUseSharedDetail ? {
            skip: true
        } : {};
        $[5] = canUseSharedDetail;
        $[6] = skip;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            variables: t4,
            ...t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const options = t6;
    const legacyResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    if (skip) {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                loading: false
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    let t7;
    if ($[12] !== canUseSharedDetail || $[13] !== legacyResult || $[14] !== sharedDetail) {
        t7 = canUseSharedDetail && sharedDetail ? {
            loading: sharedDetail.loading,
            data: sharedDetail.space ? {
                space: sharedDetail.space
            } : undefined,
            error: undefined
        } : legacyResult;
        $[12] = canUseSharedDetail;
        $[13] = legacyResult;
        $[14] = sharedDetail;
        $[15] = t7;
    } else t7 = $[15];
    const { loading: loading, data: data, error: error } = t7;
    let t8;
    if ($[16] !== data || $[17] !== includeSpaceTypeSettings) {
        t8 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[16] = data;
        $[17] = includeSpaceTypeSettings;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== error || $[20] !== loading || $[21] !== t8) {
        t9 = {
            loading: loading,
            data: t8,
            error: error
        };
        $[19] = error;
        $[20] = loading;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("89u2G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $452d11e5a10e2733$export$4ae6180efef498fb = (0, $cozmU.createContext)(undefined);
module.exports["SpaceDetailContext"] = $452d11e5a10e2733$export$4ae6180efef498fb;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $7m1pr = parcelRequire("7m1pr");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $7m1pr.RelayError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("j7B9O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $6mKj3 = parcelRequire("6mKj3");


var $aqBZ0 = parcelRequire("aqBZ0");


var $gFF2G = parcelRequire("gFF2G");

/** The id of the node if it is archived, null if it isn't, undefined if the status isn't in the store. */ const $498d9fac54b01ff5$var$readArchivedIdFromStore = (environment, operation)=>{
    if (environment.check(operation).status !== 'available') return undefined;
    const data = environment.lookup(operation.fragment).data;
    const node = data?.content?.nodes?.[0];
    if (!node) return undefined;
    return node.status === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) ? node.id ?? null : null;
};
const $498d9fac54b01ff5$export$2a442ff37ac56de5 = (contentId)=>{
    // Read the environment from context instead of `useRelayEnvironment`, which throws without a provider.
    // Callers such as the move dialog's tree can render outside one (e.g. Apollo-only tests); with no
    // environment there is nothing to read or fetch, so the hook reports "not archived".
    const environment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    const [fetchedArchivedId, setFetchedArchivedId] = (0, $cozmU.useState)(null);
    // Bumped when the stored status changes (e.g. the page is restored) so the sync read stays fresh.
    const [storeVersion, setStoreVersion] = (0, $cozmU.useState)(0);
    // Gated by `confluence_archive_folder`: with it off there is no operation, so nothing is read or
    // fetched and every consumer of this hook sees `false` (the existing behavior).
    const operation = (0, $cozmU.useMemo)(()=>contentId && environment && (0, $6mKj3.expVal)('confluence_archive_folder', 'isEnabled', false) ? (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $gFF2G.default)), {
            contentId: contentId
        }) : null, [
        contentId,
        environment
    ]);
    const storedArchivedId = (0, $cozmU.useMemo)(()=>operation && environment ? $498d9fac54b01ff5$var$readArchivedIdFromStore(environment, operation) : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps -- `storeVersion` re-reads the store after it changes
    [
        environment,
        operation,
        storeVersion
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!contentId || !operation || !environment) {
            setFetchedArchivedId(null);
            return;
        }
        const fetchSubscription = (0, $eqEJl.fetchQuery)(environment, (0, $gFF2G.default), {
            contentId: contentId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                const node = data?.content?.nodes?.[0];
                setFetchedArchivedId(node?.status === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) ? node.id ?? null : null);
            },
            error: ()=>setFetchedArchivedId(null)
        });
        const storeDisposable = environment.subscribe(environment.lookup(operation.fragment), ()=>setStoreVersion((version)=>version + 1));
        return ()=>{
            fetchSubscription.unsubscribe();
            storeDisposable.dispose();
        };
    }, [
        environment,
        operation,
        contentId
    ]);
    if (!contentId) return false;
    const archivedId = storedArchivedId !== undefined ? storedArchivedId : fetchedArchivedId;
    return archivedId === contentId;
};
module.exports["useIsContentArchived"] = $498d9fac54b01ff5$export$2a442ff37ac56de5;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<b09412736b8beecddca9546c0e2759d4>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("euozR", function(module, exports) {

var $7rovI = parcelRequire("7rovI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $8e83317b0c681e7b$export$1cffcb5a5e9a9c48 = ()=>{
    const [t0] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEditAvailable, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    const isEditorOpen = isLiveEditMode || isOnEditRoute || isAccessLinkEditAvailable && isAccessLinkEditing;
    return isEditorOpen;
};
module.exports["useIsEditorOpen"] = $8e83317b0c681e7b$export$1cffcb5a5e9a9c48;

});

parcelRegister("7rovI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $deabcafb397cc045$var$initialState = {
    isAvailable: false,
    isEditMode: false
};
const $deabcafb397cc045$var$setAvailable = (isAvailable)=>({ setState: setState })=>{
        // Leaving the route must also clear edit mode, or a later visit inherits it.
        setState(isAvailable ? {
            isAvailable: isAvailable
        } : {
            isAvailable: false,
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$enterEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: true
        });
    };
const $deabcafb397cc045$var$exitEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$actions = {
    setAvailable: $deabcafb397cc045$var$setAvailable,
    enterEditMode: $deabcafb397cc045$var$enterEditMode,
    exitEditMode: $deabcafb397cc045$var$exitEditMode
};
const $deabcafb397cc045$var$AccessLinkEditModeStore = (0, $8s9DV.createStore)({
    initialState: $deabcafb397cc045$var$initialState,
    actions: $deabcafb397cc045$var$actions,
    name: 'AccessLinkEditModeStore'
});
const $deabcafb397cc045$var$useAccessLinkEditModeStore = (0, $kBr4q.createHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$var$isOnAccessLinkRouteArgs = {
    selector: (routeName)=>{
        return (0, $1NBp8.ACCESS_LINK).name === routeName;
    }
};
/** Actions without a state subscription, so callers that only dispatch do not re-render. */ const $deabcafb397cc045$var$useAccessLinkEditModeStoreActions = (0, $kBr4q.createActionsHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$export$87e25a0d26a92fdb = ()=>{
    const isAvailable = (0, $dPJCf.useRouteName)($deabcafb397cc045$var$isOnAccessLinkRouteArgs);
    const [{ isEditMode: isEditMode }, { enterEditMode: enter, exitEditMode: exit }] = $deabcafb397cc045$var$useAccessLinkEditModeStore();
    return {
        isAvailable: isAvailable,
        isEditMode: isEditMode,
        enterEditMode: enter,
        exitEditMode: exit
    };
};
const $deabcafb397cc045$export$b9623d5da41a49e7 = ({ children: children })=>{
    const { exitEditMode: exitEditMode } = $deabcafb397cc045$var$useAccessLinkEditModeStoreActions();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            exitEditMode();
        };
    }, [
        exitEditMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["useAccessLinkEditMode"] = $deabcafb397cc045$export$87e25a0d26a92fdb;
module.exports["AccessLinkEditModeProvider"] = $deabcafb397cc045$export$b9623d5da41a49e7;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("hvS6g", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");

const $e332deabb876ffbc$export$c3136e12f209350a = (0, $3u0dr.isReactCompilerActiveV2)() ? function RelaySuspense(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { children: children, fallback: fallback, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== children || $[1] !== fallback || $[2] !== interactionName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: fallback,
            interactionName: interactionName
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = interactionName;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function RelaySuspense({ children: children, fallback: fallback, interactionName: interactionName }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: fallback,
        interactionName: interactionName
    }, children);
};
module.exports["RelaySuspense"] = $e332deabb876ffbc$export$c3136e12f209350a;

});

parcelRegister("gmWjz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4359c3e30d20b44d$export$fe81581d320ca513 = (0, $cozmU.createContext)(undefined);
const $4359c3e30d20b44d$export$ac9005ac3e3ff0e2 = ()=>{
    return (0, $cozmU.useContext)($4359c3e30d20b44d$export$fe81581d320ca513);
};
module.exports["SpaceNavigationQueryContext"] = $4359c3e30d20b44d$export$fe81581d320ca513;
module.exports["useSpaceNavigationQueryData"] = $4359c3e30d20b44d$export$ac9005ac3e3ff0e2;

});

parcelRegister("i1Dx5", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $dGmBZ = parcelRequire("dGmBZ");


var $7MZIz = parcelRequire("7MZIz");

class $1ac87ef5bde60ed4$export$681882dbe9ee66f5 {
    beginPreload() {
        this.hydrationCleanup?.();
        this.hydrationCleanup = undefined;
        this.releaseUnclaimed();
        return ++this.generation;
    }
    isCurrentPreload(generation) {
        return this.generation === generation;
    }
    getHydrationVariables() {
        const query = this.pending?.query;
        return query?.settled && !query.error && !query.disposed ? query.variables : undefined;
    }
    setHydrationCleanup(cleanup) {
        this.hydrationCleanup?.();
        this.hydrationCleanup = cleanup;
    }
    get(variables) {
        return this.entries.get((0, $eqEJl.createOperationDescriptor)((0, $dGmBZ.default), variables).request.identifier)?.query;
    }
    preload(variables) {
        const existing = this.get(variables);
        if (existing && !existing.disposed && !existing.error) return existing;
        this.releaseUnclaimed();
        const query = new (0, $7MZIz.SpaceNavigationQueryReference)(this.environment, variables);
        const entry = {
            query: query,
            readers: 0
        };
        this.entries.set(query.identifier, entry);
        this.entriesByReference.set(query, entry);
        this.pending = entry;
        return query;
    }
    retain(query) {
        const entry = this.entriesByReference.get(query);
        if (!entry || query.disposed) // A superseded render may reach its effect after its preload was cancelled.
        // It must not resurrect that execution or invalidate the current owner.
        return ()=>{};
        entry.readers++;
        this.hydrationCleanup?.();
        this.hydrationCleanup = undefined;
        if (this.pending === entry) this.pending = undefined;
        let released = false;
        return ()=>{
            if (released) return;
            released = true;
            entry.readers--;
            // A Strict Mode effect replay can immediately acquire the same reference.
            queueMicrotask(()=>{
                if (entry.readers === 0 && this.pending !== entry) this.remove(entry);
            });
        };
    }
    releaseUnclaimed() {
        if (this.pending && this.pending.readers === 0) this.remove(this.pending);
        this.pending = undefined;
    }
    remove(entry) {
        if (this.entries.get(entry.query.identifier) === entry) this.entries.delete(entry.query.identifier);
        entry.query.dispose();
    }
    constructor(environment){
        this.environment = environment;
        this.entries = new Map();
        this.entriesByReference = new WeakMap();
        this.pending = void 0;
        this.hydrationCleanup = void 0;
        this.generation = 0;
    }
}
const $1ac87ef5bde60ed4$var$owners = new WeakMap();
function $1ac87ef5bde60ed4$export$295dffbcb6e32054(environment) {
    let owner = $1ac87ef5bde60ed4$var$owners.get(environment);
    if (!owner) {
        owner = new $1ac87ef5bde60ed4$export$681882dbe9ee66f5(environment);
        $1ac87ef5bde60ed4$var$owners.set(environment, owner);
    }
    return owner;
}
function $1ac87ef5bde60ed4$export$149c437cba9daf17(environment) {
    return $1ac87ef5bde60ed4$var$owners.get(environment);
}
module.exports["getOrCreateSpaceNavigationQueryOwner"] = $1ac87ef5bde60ed4$export$295dffbcb6e32054;
module.exports["getSpaceNavigationQueryOwner"] = $1ac87ef5bde60ed4$export$149c437cba9daf17;

});

parcelRegister("7MZIz", function(module, exports) {

var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $7m1pr = parcelRequire("7m1pr");


var $dGmBZ = parcelRequire("dGmBZ");

class $613e6bc62e959e15$export$2be457a3941a6c80 {
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.unsubscribe();
        this.reference.dispose();
        // Cancellation must also release a preloader waiting for completion.
        this.finish();
    }
    constructor(environment, variables){
        this.environment = environment;
        this.reference = void 0;
        this.ready = void 0;
        this.identifier = void 0;
        this.variables = void 0;
        this.error = void 0;
        this.settled = false;
        this.failed = false;
        this.disposed = false;
        this.finish = void 0;
        this.unsubscribe = ()=>{};
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $dGmBZ.default), variables);
        this.identifier = operation.request.identifier;
        this.variables = {
            ...variables,
            ...operation.request.variables
        };
        let resolveReady = ()=>{};
        this.ready = new Promise((resolve)=>{
            resolveReady = resolve;
        });
        this.finish = ()=>{
            this.settled = true;
            resolveReady();
        };
        this.reference = (0, $6SsN4.loadQuery)(environment, (0, $dGmBZ.default), this.variables, {
            fetchPolicy: 'store-or-network'
        });
        let graphQLErrors = [];
        const subscription = this.reference.source?.subscribe({
            next: (response)=>{
                graphQLErrors = [
                    ...graphQLErrors,
                    ...(Array.isArray(response) ? response : [
                        response
                    ]).flatMap((payload)=>payload.errors ?? [])
                ];
                if (graphQLErrors.length) this.error = new (0, $7m1pr.RelayError)({
                    graphQLErrors: graphQLErrors
                });
            },
            error: (failure)=>{
                this.failed = true;
                const payloads = Array.isArray(failure) ? failure.filter((0, $7m1pr.isRelayGraphQLError)) : (0, $7m1pr.isRelayGraphQLError)(failure) ? [
                    failure
                ] : failure instanceof Error && 'source' in failure && typeof failure.source === 'object' && failure.source !== null && 'errors' in failure.source && Array.isArray(failure.source.errors) ? failure.source.errors.filter((0, $7m1pr.isRelayGraphQLError)) : [];
                this.error = (0, $7m1pr.isRelayError)(failure) ? failure : new (0, $7m1pr.RelayError)({
                    graphQLErrors: [
                        ...graphQLErrors,
                        ...payloads
                    ],
                    networkError: payloads.length ? undefined : failure instanceof Error ? failure : new Error(String(failure))
                });
                this.finish();
            },
            complete: this.finish
        });
        this.unsubscribe = ()=>subscription?.unsubscribe();
        if (!this.reference.source) this.finish();
    }
}
module.exports["SpaceNavigationQueryReference"] = $613e6bc62e959e15$export$2be457a3941a6c80;

});

parcelRegister("cpa7E", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $9fBoq = parcelRequire("9fBoq");


var $28oQf = parcelRequire("28oQf");


var $jSwpw = parcelRequire("jSwpw");

const $b58a0883d14838f7$export$651e7ee720a56f40 = (spaceKey, links, forgeApps, isSpaceAdmin)=>{
    const forgeAppsMap = forgeApps.reduce((acc, app)=>{
        return acc.set(app.id, app);
    }, new Map());
    const allAppLinks = links.filter((link)=>$b58a0883d14838f7$export$624f6de9302f0d2d(link) && !$b58a0883d14838f7$var$isBuiltInItem(link) || $b58a0883d14838f7$export$967356d6bd08d9d2(link) && forgeAppsMap.has(link.linkIdentifier))// Fill in links for Forge apps
    .map((link)=>{
        if (!$b58a0883d14838f7$export$967356d6bd08d9d2(link)) return link;
        const forgeApp = forgeAppsMap.get(link.linkIdentifier);
        return {
            ...link,
            url: $b58a0883d14838f7$export$9d0f88f6a47d6004(spaceKey, forgeApp),
            title: (0, $9fBoq.extensionTitle)(forgeApp),
            icon: {
                width: null,
                height: null,
                isDefault: null,
                path: forgeApp.properties.icon || ''
            }
        };
    }).sort((a, b)=>Number(a.position) - Number(b.position));
    // Adding forge apps that are not in the links yet
    // This could be possible for new installed forge apps
    const allForgeLinksIds = allAppLinks.filter($b58a0883d14838f7$export$967356d6bd08d9d2).map((link)=>link.linkIdentifier);
    forgeApps.forEach((forgeApp)=>{
        if (!allForgeLinksIds.includes(forgeApp.id)) {
            const forgeAppLink = {
                id: forgeApp.id,
                type: (0, $jSwpw.SpaceSidebarLinkType).FORGE,
                linkIdentifier: forgeApp.id,
                position: 0,
                hidden: false,
                webItemKey: null,
                webItemCompleteKey: null,
                title: (0, $9fBoq.extensionTitle)(forgeApp),
                url: $b58a0883d14838f7$export$9d0f88f6a47d6004(spaceKey, forgeApp),
                styleClass: null,
                icon: {
                    path: forgeApp.properties.icon || '',
                    width: null,
                    height: null,
                    isDefault: null
                },
                iconClass: null,
                canHide: null,
                tooltip: null,
                properties: forgeApp.properties
            };
            allAppLinks.push(forgeAppLink);
        }
    });
    const appsHidden = links.filter(({ webItemCompleteKey: webItemCompleteKey, hidden: hidden })=>webItemCompleteKey === (0, $28oQf.APPS_KEY) && hidden).length > 0;
    const allVisibleAppLinks = allAppLinks.filter((link)=>!link.hidden);
    const shouldRenderSpaceApps = !appsHidden && !(allAppLinks.length == 0 || allVisibleAppLinks.length == 0 && !isSpaceAdmin);
    return {
        allAppLinks: allAppLinks,
        allVisibleAppLinks: allVisibleAppLinks,
        shouldRenderSpaceApps: shouldRenderSpaceApps
    };
};
const $b58a0883d14838f7$export$9d0f88f6a47d6004 = (spaceKey, app)=>{
    return (0, $1NBp8.SPACE_FORGE_APPS).toUrl({
        spaceKey: spaceKey,
        appId: app.appId,
        envId: app.environmentId,
        forgeManifestRoute: app.properties.route
    });
};
const $b58a0883d14838f7$export$624f6de9302f0d2d = (link)=>{
    return link.webItemCompleteKey?.startsWith((0, $28oQf.CONNECT_ADDON_KEY));
};
const $b58a0883d14838f7$export$967356d6bd08d9d2 = (link)=>{
    return link.type === (0, $jSwpw.SpaceSidebarLinkType).FORGE && link.linkIdentifier;
};
const $b58a0883d14838f7$var$isBuiltInItem = (link)=>{
    const builtInItems = [
        (0, $28oQf.ANALYTICS_KEY),
        (0, $28oQf.ANALYTICS_KEY_MODERATE),
        (0, $28oQf.QUESTIONS_KEY),
        (0, $28oQf.DATABASES_KEY)
    ];
    return builtInItems.includes(link.webItemCompleteKey);
};
module.exports["getAllAppLinks"] = $b58a0883d14838f7$export$651e7ee720a56f40;
module.exports["isConnectApp"] = $b58a0883d14838f7$export$624f6de9302f0d2d;
module.exports["isForgeApp"] = $b58a0883d14838f7$export$967356d6bd08d9d2;

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;

});

parcelRegister("jSwpw", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $0f145b4629280bb6$export$3da4364c8f760e48 = /*#__PURE__*/ function(SpaceSidebarLinkType) {
    SpaceSidebarLinkType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    SpaceSidebarLinkType["FORGE"] = "FORGE";
    SpaceSidebarLinkType["PINNED_ATTACHMENT"] = "PINNED_ATTACHMENT";
    SpaceSidebarLinkType["PINNED_BLOG_POST"] = "PINNED_BLOG_POST";
    SpaceSidebarLinkType["PINNED_PAGE"] = "PINNED_PAGE";
    SpaceSidebarLinkType["PINNED_SPACE"] = "PINNED_SPACE";
    SpaceSidebarLinkType["PINNED_USER_INFO"] = "PINNED_USER_INFO";
    SpaceSidebarLinkType["WEB_ITEM"] = "WEB_ITEM";
    return SpaceSidebarLinkType;
}({});
module.exports["SpaceSidebarLinkType"] = $0f145b4629280bb6$export$3da4364c8f760e48;

});

parcelRegister("fadJK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $645e6ce7c101e8d7$export$ec7f7d400376dc53 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fQj-o",
    name: "SpaceNavigationContent",
    loader: async ()=>(await (parcelRequire("1YzxY"))).SpaceNavigationContent
});
module.exports["SpaceNavigationContent"] = $645e6ce7c101e8d7$export$ec7f7d400376dc53;

});

parcelRegister("1YzxY", function(module, exports) {

let $1706f7ed688cbaf3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1706f7ed688cbaf3$var$load("05hOp"),
    $1706f7ed688cbaf3$var$load("h1KXn"),
    $1706f7ed688cbaf3$var$load("45r7q"),
    $1706f7ed688cbaf3$var$load("6wr18"),
    $1706f7ed688cbaf3$var$load("1v24l"),
    $1706f7ed688cbaf3$var$load("hnpcA"),
    $1706f7ed688cbaf3$var$load("iSM6Z"),
    $1706f7ed688cbaf3$var$load("llcQo"),
    $1706f7ed688cbaf3$var$load("kHXvF"),
    $1706f7ed688cbaf3$var$load("ea3NB"),
    $1706f7ed688cbaf3$var$load("9TOep"),
    $1706f7ed688cbaf3$var$load("3dSbb"),
    $1706f7ed688cbaf3$var$load("e1OlX"),
    $1706f7ed688cbaf3$var$load("2gN4E"),
    $1706f7ed688cbaf3$var$load("gA528"),
    $1706f7ed688cbaf3$var$load("c1IkM"),
    $1706f7ed688cbaf3$var$load("dxKHc"),
    $1706f7ed688cbaf3$var$load("i8lZ0"),
    $1706f7ed688cbaf3$var$load("iDrFi"),
    $1706f7ed688cbaf3$var$load("ffEVr"),
    $1706f7ed688cbaf3$var$load("20wSi"),
    $1706f7ed688cbaf3$var$load("9LDVS"),
    $1706f7ed688cbaf3$var$load("kiMHu"),
    $1706f7ed688cbaf3$var$load("lEedB"),
    $1706f7ed688cbaf3$var$load("hhss7"),
    $1706f7ed688cbaf3$var$load("7EorR"),
    $1706f7ed688cbaf3$var$load("hFtKc")
]).then(()=>parcelRequire('2rynm'));

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<65ddc58d625028461cf53f05076a93e9>>
 * @relayHash 661233a47ecadf36bf6b55db313a301e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor",
                    "jira-planner-connection"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "661233a47ecadf36bf6b55db313a301e",
            "id": "606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "f7e2a69b86e03d256ceaf9a0f482bed1";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $7rovI = parcelRequire("7rovI");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEdit, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage || isAccessLinkEdit && isAccessLinkEditing) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});


//# sourceMappingURL=SpaceNavigation.92ce7c4b.js.map
